<div style="min-height: 100vh" class="card m-0">
  <div class="card-body top" style="line-height: 18px">
    <div class="content">
      <img class="mb-4" style="display: block; width: 192px" src="assets/imgs/logo.png" alt="유스플레이" />
      유스플레이는 유소년 축구팀의 경기를 사용자가 직접 실시간으로 방송할 수 있게 만들어주는 앱입니다.

      <h2 class="mt-5 mb-4 font-size-24" style="text-decoration: underline">유스플레이가 사용자의 데이터로 하는 일</h2>
      사용자의 유튜브 데이터를 불러와 사용자가 직접 실시간으로 방송을 할 수 있도록 만들어줍니다.
      <br />
      사용자의 유튜브 데이터는 저장되지 않습니다.

      <h2 class="mt-5 mb-4 font-size-24" style="text-decoration: underline">유스플레이가 사용자의 기능을 어떻게 향상시키는지</h2>
      유스플레이는 사용자의 유튜브 데이터를 불러와 유튜브에 접속하지 않고도 유소년 축구팀의 경기를 사용자가 직접 실시간으로 방송할 수 있게
      만들어줍니다.
      <br />
      또한 사용자의 팀 또는 사용자가 관심 있는 팀의 경기가 시작되었을 때 알림을 받을 수 있습니다.

      <h2 class="mt-5 mb-4 font-size-24" style="text-decoration: underline">개인정보 처리방침</h2>
      <a style="color: #4267e4" href="https://youthplay.web.app/personal" target="_blank">새 탭에서 개인정보 처리방침 페이지 열기</a>
    </div>
  </div>
</div>
